export default __webpack_public_path__ + "static/media/logo-bule.dfd9c3c2.svg";